import { render, staticRenderFns } from "./liaotianjilu.vue?vue&type=template&id=450659e4"
import script from "./liaotianjilu.vue?vue&type=script&lang=js"
export * from "./liaotianjilu.vue?vue&type=script&lang=js"
import style0 from "./liaotianjilu.vue?vue&type=style&index=0&id=450659e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports